export function ArrowChatIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      {...props}>
      <rect width={32} height={32} fill="#404040" rx={16} />
      <path
        fill="#0D0D0D"
        d="m20.754 15.4-4.164-4.163a.832.832 0 0 0-.274-.175.832.832 0 0 0-.633 0 .832.832 0 0 0-.275.175l-4.163 4.164a.836.836 0 1 0 1.182 1.182l2.74-2.748v6.32a.833.833 0 0 0 1.665 0v-6.32l2.74 2.748a.833.833 0 0 0 1.364-.271.833.833 0 0 0-.182-.911Z"
      />
    </svg>
  )
}
